import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography, { TypographyProps } from '@mui/material/Typography';
import React from 'react';

const Text = (props: TypographyProps) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    />
  );
};

export const Footer = (props: TypographyProps) => {
  const { sx, ...rest } = props;

  return (
    <Stack spacing={0} sx={sx}>
      <Text {...rest}>
        {'Copyright © '}
        <Link color="inherit" href="https://twitter.com/natsushiiio">
          なつしお
        </Link>{' '}
        {' ' + new Date().getFullYear() + '.'}
      </Text>
    </Stack>
  );
};
